var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviewTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.4,
    height: 31.412,
    viewBox: "0 0 31.4 31.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_Titolo_Intervista",
    "data-name": "icona Titolo Intervista",
    transform: "translate(-1832.147 -1899.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3116",
    "data-name": "Raggruppa 3116",
    transform: "translate(1832.847 1900)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_864",
    "data-name": "Tracciato 864",
    d: "M87.82,0a6.9,6.9,0,0,1,7.028,6.843v9.285a6.91,6.91,0,0,1-7.028,6.852H83.329a20.709,20.709,0,0,1-11.284,6.989h0a1.006,1.006,0,0,1-.986-.293.95.95,0,0,1,.085-1.363,10.152,10.152,0,0,0,3.289-5.333H71.875a7.052,7.052,0,0,1-6.511-4.217,6.639,6.639,0,0,1-.517-2.635V6.843A6.915,6.915,0,0,1,71.875,0Z",
    transform: "translate(-64.847)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.4,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3117",
    "data-name": "Raggruppa 3117",
    transform: "translate(1836.883 1909.375)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_53",
    "data-name": "Ellisse 53",
    cx: 2.813,
    cy: 2.813,
    r: 2.813,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_54",
    "data-name": "Ellisse 54",
    cx: 2.813,
    cy: 2.813,
    r: 2.813,
    transform: "translate(7.5)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_55",
    "data-name": "Ellisse 55",
    cx: 2.813,
    cy: 2.813,
    r: 2.813,
    transform: "translate(15)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewTitle);
export default __webpack_public_path__ + "static/media/interview_title.2c3f9fcc1fc8b9049e2ff6114913af78.svg";
export { ForwardRef as ReactComponent };